import { render, staticRenderFns } from "./AlumniData.vue?vue&type=template&id=942fdb1a&"
import script from "./AlumniData.vue?vue&type=script&lang=js&"
export * from "./AlumniData.vue?vue&type=script&lang=js&"
import style0 from "./AlumniData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports